module.exports = __webpack_public_path__ + "static/media/img99.446c93ad.jpg";